// Подписка на емейл-рассылку.

import dom from "../dom";
import analytics from "./analytics";

const SUBSCRIBE_URL = "https://forms.dashamail.ru/subscribe.php?list_id=80844Embedded";

// subscribe подписывает человека на рассылку
function subscribe(form) {
    dom.hide(form.querySelector(".js-subscribe"));
    dom.hide(form.querySelector(".js-success"));
    dom.show(form.querySelector(".js-progress"));
    const data = { merge_: form.email.value };

    fetch(SUBSCRIBE_URL, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    })
        .then(response => response.json())
        .then(() => onSubscribeSuccess(form))
        .catch(() => onSubscribeError(form));
}

// onSubmit отменяет стандартную отправку формы
// и асинхронно подписывает человека на рассылку
function onSubmit(event) {
    subscribe(event.target);
    event.preventDefault();
    event.stopPropagation();
}

// onSubscribeSuccess показывает успех подписки
function onSubscribeSuccess(form) {
    dom.hide(form.querySelector(".js-progress"));
    dom.show(form.querySelector(".js-success"));
    analytics.reachGoalOnce("NEWSLETTER");
}

// onSubscribeError перебрасывает на внешнюю форму подписки
function onSubscribeError(form) {
    form.removeEventListener("submit", onSubmit);
    form.submit();
}

dom.callAfterLoaded(() => {
    const forms = document.querySelectorAll(".js-newsletter-form");
    forms.forEach(form => {
        form.addEventListener("submit", onSubmit);
    });
});

export default {};
